<template>
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">心意投递</span>
        </template>
    </NavBar>
    <div class="box">
        <img src="@/assets/images/delivery-img.png" class="logo">
        <input type="text" class="input" placeholder="请您输入对方区块链地址或实名注册手机号" v-model="address">
        <div class="tip">
            <p>您的藏品一经投递无法被追回</p>
            <p>请您仔细核实对方区块链地址</p>
            <p>或实名注册手机号</p>
        </div>
        <div class="button" @click="submit">心意投递</div>
    </div>
    <div class="result" v-show="type">
        <img src="@/assets/images/close-detail-toast.png" class="close" @click="type = null">
        <p class="title">{{ type == 'success' ? '请您耐心等待！' : '投递失败！'}}</p>
        <p class="subtitle">{{ type == 'success' ? '您的爱心投递员正在帮您投递，请您通知对方耐心等待' : '请您核实对方区块链地址或手机号是否实名后重新尝试'}}</p>
        <router-link to="/" class="button">返回首页</router-link>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>